import './App.css';
import axios from 'axios';
import React, { useState } from 'react';
import { OpenSheetMusicDisplay, TransposeCalculator } from 'opensheetmusicdisplay';
import { Pitch } from 'opensheetmusicdisplay';
// const path = require('path')
// import XMLData from "flat-test.xml";
// import XMLData from "a-major.xml";
import XMLData from "MozaVeilSample.xml";
// import XMLData from "chromatic-scale.xml";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import Typography from '@mui/material/Typography';

import CircularProgress from '@mui/material/CircularProgress';

import AnnotationCanvas from "./components/AnnotationCanvas.js"
import ScoreMouseControl from "./components/ScoreMouseControl.js"
import OsmdExtension from "./components/OsmdExtension.js"
import ScoreRangeSelector from "./components/ScoreRangeSelector.js"

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import scoreCursorImage from "./cursor.png"

import theme from "./theme.js"

import settingSystem from "./SettingSystem.js"

import { getColorFromRainbowPalette } from "./ColorHelper"

import TextManager from './TextManager';

const NavigationBarResponsiveWidth = "800px";

const UseDebugXmlData = false;

const COLOR_PALETTE = [
	"#E33059", "#F75839", "#F7943D", "#e3b022",
	"#b3b020", "#95C631", "#56A754", "#11826D",
	"#3160A3", "#5B37CC", "#A347BF", "#EA57B2",
	"#E33059"
] // insert the first color at the end to make position (11/12) be the last color

export default class ScoreDisplayer extends React.Component {


	state = {
		isPlaying: false,

		isScoreLoaded: false,

		isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,

		annotationCanvas: null,

		noteNameElements: null,

		scoreMouseControlComponent: null,
		scoreRangeSelector: null,

		resetCanvasConfirmDialogOpened: false,
	};

	constructor(props) {
		super(props);

		ScoreDisplayer.singleton = this;
		
		settingSystem.register("zoomLevel", () => this.osmd.Zoom, (v) => {
			if (this.annotationCanvasRef.current != null && this.annotationCanvasRef.current.anythingOnCanvas) {
				this.tempZoomLevel = v;
				this.setState({ resetCanvasConfirmDialogOpened: true });
			} else {
				this.tempZoomLevel = null;
				this.resizeOsmd(v);
			}
		});
		settingSystem.register("noteNameMode", () => this.noteNameMode, (v) => {
			this.noteNameMode = v;
			this.updateNoteNames();
		});
		settingSystem.register("noteColorMode", () => this.noteColorMode, (v) => {
			this.noteColorMode = v;
			this.updateNoteColors();
			this.osmd.render();
		});

		settingSystem.register("showLyrics", () => this.showLyrics, (v) => {
			this.showLyrics = v;
			this.osmd.rules.RenderLyrics = v;
			//this.osmd.rules.DefaultColorLabel = "red";
			this.osmd.render();
		});

		settingSystem.register("displayTempo", () => this.tempo, (v) => {
			this.tempo = v;
		});

		settingSystem.register("displayTranspose", () => this.transpose, (v) => {
			this.transpose = v;
			let originalCursorPosition = this.osmd.cursor.iterator.timestamp;

			this.osmd.Sheet.Transpose = v;
			this.osmd.TransposeCalculator = new TransposeCalculator();

			this.onOsmdResized();

			this.scoreMouseControlComponentRef.current.setCursorPositionByTimestamp(originalCursorPosition)

			
		});
	}

	tempZoomLevel = null;

	noteNameMode = 0;
	noteColorMode = 0;

	scoreMouseControlComponentRef = React.createRef();
	scoreRangeSelectorRef = React.createRef();

	osmd = null;
	osmdExtension = null;

	showLyrics = true;

	annotationCanvasRef = React.createRef();

	playbackIntervalId = -1;

	tempo = 120;
	transpose = 0;

	lastWindowWidth = window.innerWidth;

	osmdFinishResizeTimestamp = performance.now();
	handleLastOsmdResizeRequestTimeout = null;

	startInterval() {
		return setInterval(() => {
			const osmd = this.osmd;

			// osmd.cursor.show();

			if (osmd.cursor.iterator.endReached) {
				osmd.cursor.reset();
			} else {
				osmd.cursor.next();
			}
			
		}, 500);
	}

	componentDidMount() {
		this.osmd = new OpenSheetMusicDisplay("osmdCanvas", {
			// backend: "canvas",
			drawFromMeasureNumber: 0,
			drawUpToMeasureNumber: Number.MAX_SAFE_INTEGER, // draw all measures, up to the end of the sample
			pageBackgroundColor: "#11111100",
			// pageFormat: "A4 P",
			// pageBackgroundColor: "green",
			disableCursor: false,
			followCursor: true,
			cursorsOptions: [{
				// alpha: 0.8,
				alpha: 0.0,
				color: "#42a5f5",
				follow: true,
				type: 0
			}],
			autoResize: false,
		});

		const handler = e => {
			// console.log(e.matches);
			this.setState({ isNarrowScreen: e.matches });
		};
		window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).addEventListener('change', handler);


		// axios.get(XMLData, {
		//    "Content-Type": "application/xml; charset=utf-8"
		// }).then((response) => {
		//    // console.log('Your xml file as string', response.data);

		const osmd = this.osmd;
		// console.log(osmd);

		osmd.EngravingRules.VoiceSpacingMultiplierVexflow = 2.0;
        // osmd.EngravingRules.VoiceSpacingAddendVexflow = 4.0;
		// osmd.EngravingRules.MinNoteDistance = 10.0;
		osmd.EngravingRules.RenderMultipleRestMeasures = false;

		this.updateOsmdRules();

		// osmd.EngravingRules.PageLeftMargin = 2.5;
		// osmd.EngravingRules.PageRightMargin = 2.5;

		document.addEventListener('contextmenu', event => event.preventDefault()); // prevent opening context menu

		
		if (UseDebugXmlData) {
			axios.get(XMLData, {
				"Content-Type": "application/xml; charset=utf-8"
			}).then((response) => {
				this.osmdLoadXML(response.data);
			});
		}
	}

	osmdLoadXML(xmlData) {
		const osmd = this.osmd;

		const onXmlLoaded = () => {
			if (this.state.isNarrowScreen) {
				osmd.Zoom = 0.8;
			} else {
				osmd.Zoom = 1.0;
			}

			if (this.osmd.Sheet.TitleString == "Scanned Score" || this.osmd.Sheet.TitleString == "Untitled Score") {
				this.osmd.rules.RenderTitle = false;
			} else {
				this.osmd.rules.RenderTitle = true;
			}

			// console.log(osmd.container.getBoundingClientRect().width)

			// osmd.Zoom = osmd.container.getBoundingClientRect().width / 1000;
			
			this.updateNoteColors(); // must be before the render
			
			osmd.render();

			this.updateNoteNames(); // must be after the render

			osmd.cursor.show();

			// window.ondragstart = function() {return false} // prevent ghost dragging the cursor

			this.setState({
				annotationCanvas: (
					<AnnotationCanvas
						ref={this.annotationCanvasRef}
						referenceCanvas={osmd.container}
						scrollBox={document.getElementById("MainScrollBox")}
					/>
				)
			}, () => {
				this.annotationCanvasRef.current.resetCanvas();
			});

			// for (var i = 0; i < 99; i++) {
			// osmd.cursor.next();
			// }

			// const cursorVoiceEntry = osmd.cursor.Iterator.CurrentVoiceEntries[0];
			// console.log(cursorVoiceEntry);
			// const lowestVoiceEntryNote = cursorVoiceEntry.Notes[0];
			// console.log("Stem direction of VoiceEntry under Cursor: " + cursorVoiceEntry.StemDirection);
			// console.log("base note of Voice Entry at second cursor position: " + lowestVoiceEntryNote.Pitch.ToString());

			// console.log(getNoteNameString(lowestVoiceEntryNote.Pitch))

			// console.log(lowestVoiceEntryNote.Pitch.getNoteEnumString(lowestVoiceEntryNote.Pitch.fundamentalNote) + accidentalString)
			// console.log(lowestVoiceEntryNote.getSVGGElement());

			// console.log(osmd.graphic.measureList[0][0].staffEntries[0].graphicalVoiceEntries[0].notes[0].boundingBox.absolutePosition.x * osmd.Zoom * 10 + osmd.container.offsetLeft)

			this.osmdExtension = new OsmdExtension(osmd);

			const observer = new ResizeObserver((entries) => {
				window.requestAnimationFrame(() => {
					if (Math.abs(entries[0].contentRect.width - this.lastWindowWidth) > 1) {
						this.onOsmdResized();
					}

					this.lastWindowWidth = entries[0].contentRect.width;
				});
			});

			observer.observe(this.osmd.container, {
				box: "content-box",
			});

			this.setState({
				scoreMouseControlComponent: (
					<ScoreMouseControl
						ref={this.scoreMouseControlComponentRef}
						osmd={osmd}
						scrollBox={document.getElementById("MainScrollBox")}
						osmdExtension={this.osmdExtension}
					/>
				),
				scoreRangeSelector: (
					<ScoreRangeSelector
						ref={this.scoreRangeSelectorRef}
						osmd={osmd}
						osmdExtension={this.osmdExtension}
						scrollBox={document.getElementById("MainScrollBox")}
						setCursor={(v) => {
							this.scoreMouseControlComponentRef.current.setCursorPositionByVerticalItemInfo(v)
						}}
					/>
				),
				isScoreLoaded: true,

			}, () => {
				this.scoreRangeSelectorRef.current.close();
			});

			// osmd.cursor.cursorElement.src = scoreCursorImage;
			// console.log(osmd.cursor.container)
			// osmd.cursor.cursorElement.src = scoreCursorImage;

			// osmd.cursor.cursorElement.setAttribute("src", scoreCursorImage);

			// setTimeout(()=>{this.annotationCanvasRef.current.disabled=true;}, 1000)
			// setTimeout(()=>{this.annotationCanvasRef.current.brushColor="red";}, 5000)

		}

		return osmd.load(xmlData).then(onXmlLoaded())

	}

	updateOsmdRules() {
		if (this.state.isNarrowScreen) {
			this.osmd.EngravingRules.PageLeftMargin = 2.5;
			this.osmd.EngravingRules.PageRightMargin = 2.5;
			this.osmd.EngravingRules.RenderPartNames = false;
		} else {
			this.osmd.EngravingRules.PageLeftMargin = 10;
			this.osmd.EngravingRules.PageRightMargin = 10;
			this.osmd.EngravingRules.RenderPartNames = true;
		}
	}

	onOsmdResized() {
		if (this.props.sheetMusicPlayerRef.current != null) {
			this.props.sheetMusicPlayerRef.current.pause();
		}

		console.log("OSMD resized");

		const start = performance.now();

		if (this.state.isScoreLoaded) {
			this.updateOsmdRules();

			this.updateNoteColors(); // must be before the render

			this.osmd.render();

			this.updateNoteNames(); // must be after the render
			
			this.annotationCanvasRef?.current?.resetCanvas(); // also reset the canvas
			this.scoreRangeSelectorRef?.current?.onScoreResized();

			this.osmdExtension.initialize();

			// for (let i = 0; i < 80000000;i ++) {
			// 	const f = [];
			// 	f[0] = i - i;
			// }
		}

		const end = performance.now();

		console.log(`OSMD resize finished (${end - start} ms)`);

		this.osmdFinishResizeTimestamp = performance.now();
	}

	resizeOsmd(zoomLevel) {
		const zoomLevelErrorPrevented = Math.round(zoomLevel * 100) *  0.01;
		this.osmd.Zoom = zoomLevelErrorPrevented;

		if (this.handleLastOsmdResizeRequestTimeout != null) {
			clearTimeout(this.handleLastOsmdResizeRequestTimeout);
		}

		// if the time difference is smaller than the threshold, then this function call is probably queued (i.e. deleayed onClick event callback)
		// example: click the zoom button many times very quickly. Even the clicks are before the first resize finished, the onClick functions are still called after first resize finished
		// therefore, we need to check this to prevent this expensive function being called too many times
		if (performance.now() - this.osmdFinishResizeTimestamp >= 150) {
			this.onOsmdResized();
		} else {
			// clear the last resize request ignored before
			this.handleLastOsmdResizeRequestTimeout = setTimeout(() => {
				this.onOsmdResized();
	
				this.handleLastOsmdResizeRequestTimeout = null;
			}, 200) // wait this amount of time before clear the last resize request in case there are still more incoming
		}
	}



	updateNoteColors() {
		const osmd = this.osmd;
		const mode = this.noteColorMode;

		if (mode == 1) { // colored by note pitch
			for (const [measureId, measure] of osmd.graphic.measureList.entries()) {
				for (const [trackId, track] of measure.entries()) {
					if (track == null) {
						continue;
					}
					for (const [entryId, staffEntry] of track.staffEntries.entries()) {
						for (const [_, voiceEntry] of staffEntry.graphicalVoiceEntries.entries()) {

							for (const [_, note] of voiceEntry.notes.entries()) {
								if (note.sourceNote.Pitch != null && !note.sourceNote.isRestFlag) {
									const position = ((note.sourceNote.TransposedPitch || note.sourceNote.Pitch).getHalfTone() % 12) / 12;
									note.sourceNote.noteheadColor = getColorFromRainbowPalette(position);

									// const hue = ((note.sourceNote.TransposedPitch || note.sourceNote.Pitch).getHalfTone() % 12) / 12 * 360;
									// note.sourceNote.noteheadColor = `hsl(${hue}, 100%, 45%)`
								}
							}
						}
					}
				}
			}
		} else if (mode == 2) { // colored by track
			for (const [measureId, measure] of osmd.graphic.measureList.entries()) {
				for (const [trackId, track] of measure.entries()) {
					if (track == null) {
						continue;
					}
					for (const [entryId, staffEntry] of track.staffEntries.entries()) {
						for (const [_, voiceEntry] of staffEntry.graphicalVoiceEntries.entries()) {

							for (const [_, note] of voiceEntry.notes.entries()) {
								if (note.sourceNote.Pitch != null && !note.sourceNote.isRestFlag) {
									// const hue = trackId / measure.length * 360;
									// note.sourceNote.noteheadColor = `hsl(${hue}, 100%, 20%)`

									const position = trackId / measure.length;
									note.sourceNote.noteheadColor = getColorFromRainbowPalette(position);

									// note.getSVGGElement().querySelectorAll("path").forEach(
									// (path) => {
									// path.style.fill  = "red"
									// path.style.stroke  = "red"
									// }
									// )
								}
							}
						}
					}
				}
			}
		} else { // reset
			for (const [measureId, measure] of osmd.graphic.measureList.entries()) {
				for (const [trackId, track] of measure.entries()) {
					if (track == null) {
						continue;
					}
					for (const [entryId, staffEntry] of track.staffEntries.entries()) {
						for (const [_, voiceEntry] of staffEntry.graphicalVoiceEntries.entries()) {

							for (const [_, note] of voiceEntry.notes.entries()) {
								note.sourceNote.noteheadColor = ""
							}
						}
					}
				}
			}
		}
	}

	updateNoteNames() {
		const osmd = this.osmd;

		const mode = this.noteNameMode;

		const getNoteNameString = (pitch) => {
			if (mode == 1) { // alphabets
				let accidentalString = Pitch.accidentalVexflow(pitch.accidental);
				if (!accidentalString) {
					accidentalString = "";
				}
				return Pitch.getNoteEnumString(pitch.fundamentalNote) + accidentalString;

			} else if (mode == 2) { // fixed solfege
				const solfegeNamesMap = {
					"C": "Do",
					"D": "Re",
					"E": "Mi",
					"F": "Fa",
					"G": "Sol",
					"A": "La",
					"B": "Ti",
				}

				let accidentalString = Pitch.accidentalVexflow(pitch.accidental);
				if (!accidentalString) {
					accidentalString = "";
				}
				return solfegeNamesMap[Pitch.getNoteEnumString(pitch.fundamentalNote)] + accidentalString;

			} else if (mode == 3) { // movable solfege
				// const noteNames = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
				const solfegeNames = ["Do", "Do#", "Re", "Re#", "Mi", "Fa", "Fa#", "Sol", "Sol#", "La", "La#", "Ti"];

				const key = osmd.sheet.instruments[0].playbackTranspose || 0;
				const id = (pitch.getHalfTone() + key) % 12;

				return solfegeNames[id];
			} else {
				return null;
			}
		}

		var noteNameElements = []

		var noteNameCount = 0;
		for (const [measureId, measure] of osmd.graphic.measureList.entries()) {
			for (const [trackId, track] of measure.entries()) {
				if (track == null) {
					continue;
				}
				for (const [entryId, staffEntry] of track.staffEntries.entries()) {
					for (const [_, voiceEntry] of staffEntry.graphicalVoiceEntries.entries()) {

						for (const [_, note] of voiceEntry.notes.entries()) {
							var position = note.boundingBox.absolutePosition

							if (note.sourceNote.Pitch != null && !note.sourceNote.isRestFlag) {
								// console.log(measureId, note.sourceNote);
								// var noteheadElements = note.getSVGGElement().querySelectorAll(".vf-notehead");
								// var noteheadElement = noteheadElements[0];

								const notehead = note.notehead();

								let displacedNoteOffset = 0;
								if (notehead.displaced && notehead.stem_direction == 1) {
									displacedNoteOffset = 10;
								}

								// console.log(notehead, notehead.stem_direction)

								const size = 20 * osmd.Zoom * 1.25;

								noteNameElements.push(
									<Box key={noteNameCount} sx={{
										position: "absolute",

										// bgcolor: "rgba(1,0,0,0.5)",

										display: "flex",

										minWidth: size,
										minHeight: size,

										alignItems: "center",
										justifyContent: "center",

										// left: (notehead.x + 0.5 * notehead.width)  * osmd.Zoom,
										// top: notehead.y*osmd.Zoom,
										left: (notehead.x + displacedNoteOffset + 1.0 * notehead.width) * osmd.Zoom,
										top: (notehead.y) * osmd.Zoom - 0.5 * size,
									}}>
										<Typography sx={{
											width: "100%",
											height: "100%",

											fontSize: 0.6 * size,

											textAlign: "left",
											// verticalAlign: "middle",
											color: "white",
											textShadow: "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black, 0px -1px 0 black, 0px 1px 0 black, -1px 0px 0 black, 1px 0px 0 black",
											// textShadow: "0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black ",

										}}>{getNoteNameString(note.sourceNote.TransposedPitch || note.sourceNote.Pitch)}</Typography>
									</Box>
								)

								noteNameCount++;
							}


						}
					}
				}
			}
		}

		this.setState({ noteNameElements: noteNameElements })
	}

	playOrPause(callback) { //NOTE: only for testing

		this.setState({ isPlaying: !this.state.isPlaying }, () => {
			if (this.state.isPlaying) {
				this.playbackIntervalId = this.startInterval();
			} else {
				clearInterval(this.playbackIntervalId);
				this.playbackIntervalId = -1;
			}

			callback();
		}
		);
	}



	render() {
		const closeConfirmDialog = () => {
			this.setState({ resetCanvasConfirmDialogOpened: false });
		};

		return (
			<Box id="MainScrollBox" sx={{
				flex: this.props.isHidden? 0 : 1,
				overflowY: "scroll",
			}} >

				{!this.state.isScoreLoaded ? <Box
					sx={{
						// position:"absolute",
						bgcolor: "#00000000",
						// top:0,
						// left:0,
						width: "100%",
						height: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
					onClick={(e) => { e.stopPropagation(); }}
				><CircularProgress disableShrink sx={{}} /></Box> : null}

				<Box sx={{
					flex: 1,
					overflow: "hidden",
					position: "relative",
				}} >

					<Box id="osmdCanvas" className="osmdCanvas" sx={{
						// display:"none",
						height: "100%",
						
						// maxWidth: "800px",
						// margin: "auto auto",

						minHeight: "80vh", // prevent clipping of the range selector close button
						scrollbarGutter: "auto",
						overflow: "hidden",
					}} />

					{this.state.annotationCanvas}

					<Box>
						{this.state.noteNameElements}
					</Box>

					{this.state.scoreMouseControlComponent}
					{this.state.scoreRangeSelector}
					{/*
					<Box sx={{
						// display:"none",
						height:"1000px",
						background: "linear-gradient(0deg, black, red)",
						scrollbarGutter: "auto",
						overflow: "hidden"
					}} />*/}
				</Box>

				<Dialog
					open={this.state.resetCanvasConfirmDialogOpened}
					onClose={closeConfirmDialog}
				>
					<DialogTitle>
						{TextManager.getText("delete_all_notations")}
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{TextManager.getText("zoom_delete_all_notataions")}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button variant="contained" onClick={() => {
							this.resizeOsmd(this.tempZoomLevel);
							this.annotationCanvasRef.current.resetCanvas();
							closeConfirmDialog();
						}}>
							{TextManager.getText("confirm")}
						</Button>
						<Button variant="outlined" onClick={closeConfirmDialog} autoFocus>
							{TextManager.getText("cancel")}
						</Button>
					</DialogActions>
				</Dialog>

				{/* {AnnotationCanvas.createResetConfirmDialog(
					this.state.resetCanvasConfirmDialogOpened,
					closeConfirmDialog,
					() => {
						this.resizeOsmd(this.tempZoomLevel);
						this.annotationCanvasRef.current.resetCanvas();
						closeConfirmDialog();
					}
				)} */}
			</Box>
		);
	}
};